import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import * as styled from './styled'

function PrivacyPolicyPage() {
	const location = useLocation()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}, [location])

	return (
		<styled.PrivacyPolicyWrapper>
			<styled.PrivacyPolicyHeader>
				Політика конфіденційності
			</styled.PrivacyPolicyHeader>
			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Загальні положення
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Політика конфіденційності (далі - Політика) встановлює принципи щодо
						дотримання конфіденційності і захисту персональних даних, а також
						загальний порядок і умови роботи. В процесі обробки персональних
						даних Контакт-Центр керується Законом України «Про захист
						персональних даних» № 2297- VI від 01.06.2010 (далі - Закон), іншими
						нормативно - правовими актами України, внутрішніми документами, що
						регламентують діяльність. Користування ресурсу, встановленими на
						ньому сервісами означає, що Користувач згоден з цією політикою
						збереження конфіденційності і приймає умови, зазначені в Політиці. У
						разі незгоди з умовами Політики Користувач повинен припинити
						користуватися Вебсайтом і утриматися від використання сервісів. Дана
						Політика застосовується тільки до Вебсайтів і ресурсів. Ресурс може
						містити посилання на інші сервіси і Вебсайти Інтернету, якими не
						керує Контакт-Центр. Контакт-Центр не несе відповідальність за
						Вебсайти, сервіси третіх осіб, на які Користувач може перейти по
						посиланнях, доступним на Вебсайтах, якими не керує Контакт-Центр.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Отримання персональних даних
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Контакт-Центр отримує персональні дані на підставі добровільного та
						усвідомленого рішення суб'єкта персональних даних щодо передачі
						даних. Обробці підлягають тільки ті персональні дані і тільки в тому
						обсязі, які відповідають цілям їх обробки. Персональні дані
						обробляються і зберігаються відповідно до норм законодавства
						України. При роботі на Ресурсі Контакт-Центр, Користувачеві
						пропонується ввести деякі персональні дані (прізвище, ім'я, по
						батькові, адреса електронної пошти, номер контактного телефону).
						Контакт-Центр може запитати додаткові дані, які знадобляться для
						надання послуг Користувачу (для реалізації зобов'язань). Користувач
						зобов'язується надати достовірну інформацію і несе персональну
						відповідальність за достовірність інформації. Адміністрація
						Контакт-Центру не перевіряє достовірність персональних даних,
						наданих Користувачем. У разі відмови від надання всієї необхідної
						інформації для реалізації прийнятих зобов'язань, Контакт-Центр
						залишає за собою право відмовити в наданні послуг або призупинити їх
						дію.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Використання персональних даних
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Персональні дані не підлягають розголошенню і не передаються третій
						стороні, якщо це не вимагає виконання прийнятих зобов'язань по
						реалізації послуг або якщо це не суперечить чинному законодавству
						України. Отримані персональні дані використовуються тільки для
						надання замовлених послуг (реалізації зобов'язань). Якість і
						швидкість надання послуг безпосередньо залежить від достовірності
						наданої інформації. Деякі персональні дані можуть використовуватися
						для письмових повідомлень (інформування) Користувача на замовлення,
						про нові пропозиції, а також з метою опитувань, маркетингових,
						статистичних та інших досліджень. Користувач в будь-який момент може
						відмовитися (відписатися) від інформування.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Згода на обробку персональних даних
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Користувач, передаючи свої персональні дані, - погоджується з
						умовами Політики конфіденційності. Всі особи, які надали персональні
						дані через Вебсайт або іншим способом дають свою згоду на обробку
						персональних даних. Згода на обробку персональних даних поширюється
						як на передану інформацію за допомогою заповнення форм на Вебсайті,
						так і на інформацію, передану в Контакт-Центр на друкованих носіях
						(копії документів). Згода на обробку персональних даних може бути
						відкликана шляхом письмового повідомлення.
					</p>

					<p>
						Обробка персональних даних здійснюється виключно в обсязі,
						необхідному для:
					</p>

					<ul>
						<li>
							забезпечення функціонування особистого кабінету користувача;
						</li>
						<li>
							надання та супроводу послуг, за якими користувач звертається;
						</li>
						<li>
							покращення якості роботи Контакт-Центру та пов’язаних міських
							цифрових сервісів;
						</li>
						<li>
							інформування про оновлення, нові функції або сервіси (у межах,
							дозволених законодавством).
						</li>
					</ul>

					<p>
						Персональні дані не підлягають розголошенню і не передаються третій
						стороні, якщо це не вимагає виконання прийнятих зобов'язань по
						реалізації послуг або якщо це не суперечить чинному законодавству
						України.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>Діти</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Контакт-Центр цілком поділяє настороженість батьків в питаннях
						несанкціонованих дій дітей при їх відвідуванні будь-яких
						Інтернет-ресурсів. Контакт-Центр навмисно не збирає персональні дані
						від дітей у віці до 18 років. Настійно просимо всіх користувачів
						молодше 18 років отримувати дозвіл батьків або опікунів, перш ніж
						надавати будь-яку персональну інформацію. Якщо кому-небудь стало
						відомо, що фізична особа у віці до 18 років передало свої
						персональні дані без дозволу батьків, - негайно повідомте нам про
						це. Ми вживемо заходів для видалення такої інформації в можливо
						короткі терміни.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Захист персональних даних
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Контакт-Центр приймає розумні організаційні заходи для захисту
						персональних даних Користувача від неправомірного або випадкового
						доступу, знищення, перекручення, поширення, а також від інших
						неправомірних дій з боку третіх осіб. У той же час, Контакт-Центр не
						може гарантувати абсолютного усунення ризику несанкціонованого
						зловживання персональною інформацією. Негайно зв'яжіться з нами,
						якщо стане відомо про будь-яке порушення інформаційної безпеки.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Видалення персональних даних
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Відповідно до чинного законодавства України, в системі реалізовано
						право Користувача на видалення особистих даних. Користувач в
						будь-який момент має право видалити свій обліковий запис із Системи
						та свої облікові дані та відомості (у тому числі дані, які було
						надано користувачем під час реєстрації у Системі. Робота деяких
						можливостей Вебсайту, для яких необхідна наявність інформації про
						Користувача, може бути припинена з моменту видалення даних.
						Достатнім повідомленням Користувача про видалення облікових даних
						буде повідомлення про видалення облікового запису, яке з'явиться за
						допомогою діалогового вікна.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Інтеграція з іншими інформаційними системами
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Для забезпечення функціонування сервісів Вебсайт може взаємодіяти з
						іншими державними, муніципальними або комерційними інформаційними
						системами. Такі інтеграції можуть здійснюватися з метою:
					</p>

					<ul>
						<li>
							отримання або передачі даних, необхідних для надання послуг;
						</li>
						<li>забезпечення авторизації або ідентифікації користувачів;</li>
						<li>перевірки даних, поданих користувачами;</li>
						<li>
							забезпечення доступу до сервісів інших інформаційних систем.
						</li>
					</ul>

					<p>
						Передача персональних даних у межах таких інтеграцій здійснюється
						виключно у випадках, передбачених законодавством України, або за
						згодою суб’єкта персональних даних. Вебсайт не несе відповідальності
						за політики конфіденційності інших систем, до яких користувач
						переходить або з якими здійснюється інтеграція.
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>


			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Обробка іншої інформації
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Під час користування сайтом можуть оброблятись додаткові види інформації, як персональні, так і такі, що не є персональними даними у розумінні чинного законодавства. Обробка інформації відбувається зокрема за допомогою: 
					</p>

					<ul>
						<li>
						cookies (для збереження налаштувань сайту); 
						</li>
						<li>Google Analytics (для аналізу трафіку сайту). </li>
					</ul>

					
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
					Використання файлів Сookie
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						Файли cookie — це текстові файли, що містять невеликий обсяг інформації, які передаються веб-браузером та зберігаються на пристрої користувача (комп’ютері, мобільному телефоні чи іншому пристрої, за допомогою якого здійснюється доступ до Вебсайту). 
					</p>

					<p>Файли cookie можуть бути:</p>
					<ul>
						<li>
							Постійними (зберігаються до моменту видалення користувачем); 
						</li>
						<li>
							Сесійними (діють лише протягом одного сеансу користування браузером); 
						</li>
						<li>Основними (встановлюються безпосередньо Вебсайтом); </li>
						<li>Сторонніми (встановлюються іншими сайтами чи сервісами).</li>
					</ul>

					<p>Звертаємо увагу:</p>
					<ul>
						<li>
							Під час повторного відвідування Вебсайту файли cookie оновлюються; 
						</li>
						<li>
							Більшість веб-браузерів за замовчуванням дозволяють зберігання cookie-файлів; 
						</li>
						<li>
						Вимкнення файлів cookie може призвести до обмеженого функціонування окремих сервісів Вебсайту. 
						</li>
					</ul>

					<p>
						Класифікація cookie-файлів згідно з рекомендаціями Міжнародної торгової палати: 
					</p>
					<ul>
						<li>
							<strong>Строго необхідні файли cookie</strong> (забезпечують базові функції Вебсайту, такі як навігація, доступ до захищених сторінок, авторизація, пошук по ресурсу тощо).
						</li>
						<li>
							<strong>Експлуатаційні файли cookie</strong> (збирають статистичну інформацію про взаємодію користувача з Вебсайтом: час перебування, найбільш відвідувані сторінки, популярні розділи. Такі дані використовуються виключно з аналітичною метою).
						</li>
						<li>
							<strong>Функціональні файли cookie</strong>  (зберігають налаштування та параметри користувача між сесіями: мову інтерфейсу, геолокацію, введені дані (наприклад, ім’я користувача), участь в опитуваннях, взаємодію з відео- та соціальними плагінами).
						</li>
					</ul>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>

			<styled.PrivacyPolicyContainer>
				<styled.PrivacyPolicyTitle>
				  Заключні положення
				</styled.PrivacyPolicyTitle>
				<styled.PrivacyPolicyText>
					<p>
						На розсуд Контакт-Центру в положення даної Політики можуть вноситися зміни (редагування, доповнення) без попереднього повідомлення. Нові положення Політики конфіденційності вступають в силу з моменту їх публікації на Вебсайті, якщо інше не передбачено новою редакцією Політики. Всі пропозиції, побажання та питання з приводу Політики слід надсилати за вказаними на Вебсайті контактними даними. 
					</p>
				</styled.PrivacyPolicyText>
			</styled.PrivacyPolicyContainer>
		</styled.PrivacyPolicyWrapper>
	)
}

export default PrivacyPolicyPage
